import React, {Component, useDebugValue, useSyncExternalStore} from 'react';
import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { Button, Alert, Modal, Col } from 'react-bootstrap';
import OrganigramaDataService from './services/organigrama.service.js';
import { Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import {dtForInputDate} from './AuxiliaryFunctions.js'

function UpdateOrganigrama(props) { 

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      /*
      primernombre: props.edituser.primernombre,      
      segundonombre: props.edituser.segundonombre,
      primerapellido: props.edituser.primerapellido,
      segundoapellido: props.edituser.segundoapellido,
      fechadenacimiento: dtForInputDate(props.edituser.fechadenacimiento),
      telefonomovil: props.edituser.telefonomovil,
      email: props.edituser.email,
      habilitado: props.edituser.habilitado,
      curp: props.edituser.curp,
      */
    },
  });  

  const [lgShow, setLgShow] = useState(false);
  const [Errmessage, setErrmessage] = useState("");
  const [Showerror, setShowerror] = useState("");
  const [Sucmessage, setSuccmessage] = useState("");
  const [Showsuccess, setShowsuccess] = useState("");
  const [Submitted, setSubmitted] = useState(false);
  const [mode, setMode] = useState(props.mode);


  const [nombreorganigrama, setnombreorganigrama] = useState("");
  const [descripcionorganigrama, setdescripcionorganigrama] = useState("");     
  
  const { user } = useSelector(state => state.auth);

  const onChangenombreOrganigrama = (e) => {  
    //console.log(e.target.value);
    const nombreorganigrama = e.target.value;
    setnombreorganigrama(nombreorganigrama);
  };

  const onChangedescripcionorganigrama = (e) => {  
    //console.log(e.target.value);
    const descripcionorganigrama = e.target.value;
    setdescripcionorganigrama(descripcionorganigrama);
  };
  
  const handleClose = () => {
    window.location.reload();
    setLgShow(false);
  }
  
  const handleShow = () => {
    OrganigramaDataService.get(props.id)
    .then(response => {
        console.log(response.data);
        setSuccmessage('');
        setErrmessage('');
        setShowerror(false);
        setShowsuccess(false);      
        setnombreorganigrama(response.data.nombreorganigrama);
        setdescripcionorganigrama(response.data.descripcionorganigrama);
        setLgShow(true);        
      })      
    .catch(e => {
      console.log(e);
    });     
  }

  let handleValidations = () => {
    /*
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Campos requeridos.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('El correo no es válido.');
        setShowerror(true);      
        return;
      }
    }
    */
    saveOrganigrama();
  } 

  let saveOrganigrama = (e)  =>{ 
    console.log(e);
    console.log(nombreorganigrama);
    console.log(descripcionorganigrama);
    console.log(e.nombreorganigrama);
    console.log(e.descripcionorganigrama);   

    if (nombreorganigrama.length == 0) {
      setErrmessage("El nombre del organigrama no puede ser vacío.");
      setShowerror(true);
    }  
    else {
      var data = {
        nombreorganigrama: e.nombreorganigrama,
        descripcionorganigrama: e.descripcionorganigrama
      }
      
      console.log(data);
      
      OrganigramaDataService.update(props.id, data)
      .then(response => {
        console.log(response);
        setSubmitted(true);
        setSuccmessage('Se actualizó el organigrama.');
        setShowsuccess(true);
        setErrmessage('');
        setShowerror(false);        
        handleClose();
      })
      .catch(e => {
        console.log(e);
        setErrmessage(e.response?e.response.data.message:e.message);
        setShowerror(true);      
        setSuccmessage('');
        setShowsuccess(false);            
      })   
  
    }    
  }


    return (
      <>
        <Button variant="secondary" onClick={handleShow}><FaEdit size={15}/></Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => {handleClose();setLgShow(false)}}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Actualizar organigrama'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form noValidate onSubmit={handleSubmit(saveOrganigrama)}>
              <Row className='mt-2'>
                <Col className='col-md-3' md={10}>
                    <Controller
                        name="nombreorganigrama"
                        control={control}
                        onChange={onChangenombreOrganigrama}
                        defaultValue={nombreorganigrama}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Form.Control
                            {...field}
                                className="m-2"
                                type="text"
                                placeholder="Nombre organigrama"
                                isInvalid={errors.nombreorganigrama}
                                
                            />
                        )}
                    />
                    {errors.nombreorganigrama && (
                        <Form.Control.Feedback type="invalid">
                            Se requiere el nombre del organigrama.
                        </Form.Control.Feedback>
                    )}
                </Col>                

                <Col className='col-md-6' md={12}>
                  <Controller
                    name="descripcionorganigrama"
                    control={control}
                    onChange={onChangedescripcionorganigrama}
                    defaultValue={descripcionorganigrama}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="text"
                          placeholder="Descripción organigrama"
                          isInvalid={errors.descripcionorganigrama}
                          
                      />
                    )}
                  />
                  {errors.descripcionorganigrama && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere la descripción del organigrama.
                    </Form.Control.Feedback>
                  )}        
                </Col>
              </Row>
              <hr />
              <div className="d-flex justify-content-start flex-wrap">      
         
                <button className="btn btn-secondary btn-block">
                  Guardar y cerrar
                </button>            
              </div> 

            </Form>
              {Showerror && (
                <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                  <Alert.Heading>Error</Alert.Heading>
                  <p>{Errmessage}</p>
                </Alert>      
              )}
              {Showsuccess && (
                <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                  <Alert.Heading>Hecho</Alert.Heading>
                  <p>{Sucmessage}</p>
                </Alert>      
              )}     
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default UpdateOrganigrama;